import ChoiceField from '../../../fields/ChoiceField';
import { getRoutingMode, routingModeItems } from '../routingModes';

const RoutingModeChoiceField = ({ routingMode, setValue, cellControl, disabled }) => {
    const selectedRoutingMode = getRoutingMode(routingMode);
    return <ChoiceField
        selectedItem={routingModeItems.find(item => item.value === selectedRoutingMode)}
        items={routingModeItems}
        setValue={setValue}
        cellControl={cellControl}
        excludeNone
        disabled={disabled}
    />
}

export default RoutingModeChoiceField;
